import { IAppEvents } from "@cayo/shared/components/App/types";
import LiteEvent from "@cayo/shared/settings/LiteEvent";

export const appEvents = new LiteEvent<IAppEvents>();
